const appInfo = {
    title: 'Sundance Medical Finance'
};
export default appInfo;

